var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoSettings = function SvgVideoSettings(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5097 0H2.22624C1.00181 0 0 1.00559 0 2.23464V9.76536C0 10.9944 1.00181 12 2.22624 12H11.5097C12.7341 12 13.7359 10.9944 13.7359 9.76536V2.23464C13.7359 0.98324 12.7341 0 11.5097 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7004 1.22905C18.5668 1.2514 18.4333 1.31844 18.322 1.38547L14.849 3.39665V8.58101L18.3442 10.5922C18.9898 10.9721 19.7913 10.7486 20.1697 10.1006C20.281 9.89944 20.3478 9.67598 20.3478 9.43017V2.52514C20.3478 1.69832 19.5686 1.02793 18.7004 1.22905Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "video-settings.6039b2e517d1eb7a86387b65920fd3cd.svg";